<template>
  <div class="heightPage quick"
       style="overflow: auto">
    <div class="gzt_title">
      <!-- <el-page-header @back="goBack"> </el-page-header> -->

    </div>

    <el-form ref="topForm"
             :model="topForm"
             label-width="80px"
             :rules="rules"
             v-if="!this.$route.query.id"
             size="small"
             class="topForm"
             v-enterToNext="true">
      <div style="padding-left: 20%;">
        <el-form-item label="企业">
          <el-select v-model="topForm.customerId"
                     clearable
                     filterable
                     @change="PositionList"
                     placeholder="请选择">
            <el-option v-for="item in companyList"
                       :key="item.Id"
                       :label="item.customerName"
                       :value="item.id">
            </el-option>
          </el-select>
          <span style="
                text-decoration: underline;
                cursor: pointer;
                color: #409eff;
                margin-left: 8px;
              "
                @click="addCustomerDrawerShow = true">
            新增
          </span>

        </el-form-item>

        <el-form-item label="职位">
          <el-select v-model="
                    topForm.positionId"
                     clearable
                     filterable
                     @change="$forceUpdate(),listMatching('positionList', 'posAutoInt', topForm.positionId),listMatching('positionList', 'positionName',  topForm.positionId,'positionName');"
                     placeholder="请选择职位">
            <el-option v-for="item in positionList"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id">
            </el-option>
          </el-select>

          <span style="
                text-decoration: underline;
                cursor: pointer;
                color: #409eff;
                margin-left: 8px;
              "
                @click="addPositionDrawerShow = true">
            新增
          </span>

        </el-form-item>

        <el-form-item label="人员状态"
                      prop="isInsder"
                      style="position: relative;">
          <el-select v-model="topForm.userState"
                     clearable
                     placeholder="请选择状态">
            <el-option v-for="item in statusList"
                       :key="item.Value"
                       :label="item.value"
                       :value="item.num"></el-option>
          </el-select>
          <div style="width: 42px;display: inline-block;"></div>
          <!-- <el-tooltip class="item"
                      style="position:absolute;left:220px;"
                      effect="dark"
                      :disabled="Boolean(topForm.customerId && topForm.positionId && Boolean(topForm.userState))  "
                      :content="!(topForm.customerId && topForm.positionId && topForm.userState) ? '需要选择企业，职位和状态用以生成二维码' : '' "
                      placement="bottom">
            <el-button size="small"
                       type="success"
                       :disabled="!(topForm.customerId && topForm.positionId && topForm.userState)"
                       @click="openDialog">二维码录入</el-button>
          </el-tooltip> -->
        </el-form-item>

        <el-form-item label="入职时间"
                      v-if="topForm.userState == 6"
                      prop="edTime">
          <el-date-picker v-model="topForm.edTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择入职时间">
          </el-date-picker>
          <div style="width: 20px;display: inline-block;"></div>

        </el-form-item>

        <el-form-item label="离职时间"
                      v-if="topForm.userState == 7 || topForm.userState == 8"
                      prop="edTime">
          <el-date-picker v-model="topForm.edTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择离职时间">
          </el-date-picker>
          <div style="width: 20px;display: inline-block;"></div>

        </el-form-item>
      </div>
      <el-divider content-position="center">人员信息</el-divider>
      <div style="padding-left: 20%;">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick"
                 style="width: 300PX;">
          <el-tab-pane label="单人录入"
                       name="0"></el-tab-pane>
          <el-tab-pane label="导入excel"
                       name="1"></el-tab-pane>
          <el-tab-pane label="人员库选择"
                       name="2"></el-tab-pane>
        </el-tabs>
        <el-form-item label="姓名"
                      prop="cname">
          <el-input size="small"
                    v-model="topForm.cname"
                    style="width:200px;"></el-input>
          <div style="width: 42px;display: inline-block;"></div>
        </el-form-item>
        <el-form-item label="手机号码"
                      prop="tel">
          <el-input size="small"
                    v-model="topForm.tel"
                    style="width:200px;"
                    maxlength="11"></el-input>
          <div style="width: 42px;display: inline-block;"></div>
        </el-form-item>
        <el-form-item label="身份证号"
                      prop="identityCard">
          <el-input size="small"
                    v-model="topForm.identityCard"
                    style="width:200px;"
                    maxlength="18"></el-input>
          <div style="width: 42px;display: inline-block;"></div>
        </el-form-item>
        <el-button type="primary"
                   @click="onSubmit()"
                   style="margin-left: 110PX;"
                   v-if="verifyPermission('Add')"
                   size="small">保存</el-button>
      </div>
    </el-form>

    <div class="gzt_foundationBtn"
         v-if="!this.$route.query.id">

      <!-- <el-button size="small"
                 type="primary"
                 @click="importVisible = true"
                 style="margin-left: 15px">导入excel</el-button>
      <el-button size="small "
                 type="primary"
                 plain
                 @click="noticeDialogVisible = true"
                 v-if="verifyPermission('Add') && type != 3"
                 icon="el-icon-plus">人员库选择</el-button> -->
    </div>
    <el-divider content-position="center">操作记录</el-divider>

    <MyTable :tableData="tableData"
             :tableConfig="tableConfig"
             :height="tableHeight"
             :indexFlag="false"
             @selectionChange="handleSelectionChange">
      <template v-slot:index="slotData">
        {{ slotData.scope.$index + 1 }}
      </template>
      <!-- <template v-slot:name="slotData">
        <el-input size="small"
        
                  v-model="slotData.scope.row.name"></el-input>
      </template> -->

      <template v-for="item in tableConfig"
                v-slot:[item.slotName]="slotData">
        <el-select filterable
                   v-if="item.slotName=='sex'"
                   v-model="slotData.scope.row.sex"
                   :key="item.field+'a'"
                   clearable
                   style="width: 100%"
                   placeholder="请选择性别">
          <el-option label="男"
                     value="男"></el-option>
          <el-option label="女"
                     value="女"></el-option>
        </el-select>

        <el-input v-else
                  size="small"
                  :class="flag == slotData.scope.$index + item.slotName ? 'inputDeep' : ''"
                  :key="item.slotName"
                  v-model="slotData.scope.row[item.field]"></el-input>
      </template>

    </MyTable>
    <Pagination :total="total"
                style="margin-top: 10px;"
                @getNewData="getNewData"
                ref="pagination" />

    <el-dialog title="批量录入人员"
               :visible.sync="fileVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="440px"
               center>
      <div style="display: flex; justify-content: center">

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   :loading="submitLoading"
                   @click="fileVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量导入"
               :visible.sync="importVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="880px"
               @close="resetImport,activeName='0'"
               center>
      <div class="file">
        <div class="title">
          <span class="num">1</span>
          <span class="tip">请下载模板并进行填写</span>
        </div>
        <div style="padding: 10px 70px">
          <el-link type="success"
                   icon="el-icon-download"
                   @click="downloadDoc">下载模板</el-link>
        </div>
      </div>
      <div class="file">
        <div class="title">
          <span class="num">2</span>
          <span class="tip">将填写好的Excel拖拽至下方进行上传</span>
        </div>

        <el-upload class="upload-demo"
                   drag
                   accept=".xls,.xlsx"
                   :http-request="uploadfile"
                   :limit="1"
                   action=""
                   :auto-upload="false"
                   ref="upload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip"
               slot="tip">
            只能上传xls/xlsx文件，且只能上传一个(重复的数据会采用最新的进行覆盖)
          </div>
        </el-upload>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="uploadServe">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="二维码录入"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center
               @close="closeDialog">
      <div style="display: flex; justify-content: center">
        <img :src="imgPath"
             alt=""
             v-if="$shareType == 2" />
        <div id="qrcode"
             ref="qrcode"
             v-if="$shareType == 1"></div>
      </div>
    </el-dialog>
    <notifyCard @colseDrawer="noticeDialogVisible = false,activeName = '0'"
                :visible.sync="noticeDialogVisible"
                @add="introduce"
                importName="addTimesheet" />
    <AddCustomer :drawerShow="addCustomerDrawerShow"
                 title="新增企业"
                 operation="add"
                 @colseDrawer="addCustomerDrawerShow = false"
                 @refreshData="
        () => {
          getCompanyList();
        }
      " />
    <AddPosition :drawerShow="addPositionDrawerShow"
                 :companyId="topForm.customerId"
                 operation="add"
                 @colseDrawer="addPositionDrawerShow = false"
                 @refreshData="PositionList" />
  </div>
</template>

<script>
import Vue, { del } from 'vue'
import MyTable from "@/components/Table";
import notifyCard from "../purchaseInsurance/notifyCard.vue";
import AddCustomer from "../customer_center/AddCustomer.vue";
import AddPosition from "../position_center/AddPosition.vue";
import IDCard from "china-id-card";
import * as xlsx from 'xlsx'
import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
export default {
  //import引入组件才能使用
  components: {
    MyTable,
    notifyCard,
    AddCustomer,
    AddPosition
  },
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value || value == undefined) {
        callback();
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      console.log(value);

      if (!value || value == undefined) {
        callback();
        return
      }
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    return {

      tableHeight: "56vh",
      tableConfig: [
        {
          field: "bomCreateDate",
          label: "操作日期",
          flag: true,
          align: 'center',
          minWidth: 170,
        },
        {
          field: "bomNo",
          label: "操作单号",
          flag: true,
          align: "center",
          minWidth: 180,
        },
        {
          field: "cname",
          label: "姓名",

          flag: true,
          align: "center",
          minWidth: 120,
        },
        {
          field: "sex",
          label: "性别",

          flag: true,
          align: "center",
          minWidth: 90,
        },

        {
          field: "tel",
          label: "手机号码",

          align: "center",
          minWidth: 150,
          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证号码",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          field: "bomCustomerName",
          label: "企业",
          align: "center",
          minWidth: 150,
          flag: true,
        },
        {
          field: "bomPositionName",
          label: "职位",

          align: "center",
          minWidth: 150,
          flag: true,
        },

        {
          field: "defaultBankName",
          label: "银行名称",
          align: "center",
          minWidth: 150,
          flag: true,
        },
        {
          field: "defaultBankNo",
          label: "银行卡号",
          align: "center",
          minWidth: 150,
          flag: true,
        },

        {
          field: "emergencyContact",
          label: "紧急联系人",
          align: "center",
          minWidth: 120,
          flag: true,
        },
        {
          field: "emergencyContactTel",
          label: "紧急联系人电话",
          align: "center",
          minWidth: 150,
          flag: true,
        },
      ],
      statusList: [
        {
          value: "待处理",
          num: 1,
        },
        {
          value: "待面试",
          num: 2,
        },
        {
          value: "面试未通过",
          num: 3,
        },
        {
          value: "待入职",
          num: 4,
        },
        {
          value: "未入职",
          num: 5,
        },
        {
          value: "已入职",
          num: 6,
        },
        {
          value: "已离职",
          num: 8,
        },
        {
          value: "已离职(自离)",
          num: 7,
        },
      ],
      tableData: [],
      AddCustomer: false,
      topForm: { userState: '' },
      Ids: [],
      systemData: [],
      activeName: '0',
      flag: 0,
      QRVisible: false,
      fileVisible: false,
      addCustomerDrawerShow: false,
      imgPath: "",
      posAutoInt: '',
      AllData: [],
      factAutoInt: '',
      importVisible: false,
      positionList: [],
      addPositionDrawerShow: false,
      submitLoading: false,
      total: 0,
      noticeDialogVisible: false,
      id: "",
      arrayList: [],
      companyList: [],
      type: "",
      rules: {
        cname: [
          { required: true, message: "请输入姓名", trigger: "blur" },

        ],
        tel: [
          {
            required: false,
            message: "请输入手机号码",
            trigger: "blur",
          },
          { validator: validatePhone, trigger: "blur" },
        ],
        identityCard: [
          { required: false, message: "请输入身份证", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        positionId: [
          { required: true, message: "请选择职位", trigger: "change" },
        ],
        edTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
      },
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {
    let detail = JSON.parse(window.localStorage.getItem("userInfo"));
    let Companydetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    this.userAutoIntId = detail.autoIntId;
    this.CompanyAutoIntId = Companydetail.autoIntId;

    this.getBomUserList()
    this.getCompanyList();
  },
  // 方法集合
  methods: {
    closeDialog () { },
    downloadDoc () {
      // 创建一个<a></a>标签
      const a = document.createElement("a");
      a.href = "../excel/userTemplate.xls";
      a.download = "userTemplate.xls";

      // 障眼法藏起来a标签
      a.style.display = "none";
      // 将a标签追加到文档对象中
      document.body.appendChild(a);
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click();
      // 一次性的,用完就删除a标签
      a.remove();
    },
    //生成微信二维码
    qrcode () {
      if (this.$shareType == 2) {
        this.submitLoading = true;
        let sendData = {
          page: "pages/home/modifyPersonnelStatus",
          check_path: false,
          width: 150,
          scene: `cid=${this.userAutoIntId}-${this.CompanyAutoIntId}-${this.factAutoInt}-${this.posAutoInt}-${this.topForm.userState}`,
        };
        this.GetUnlimitedQRCode(sendData).then((res) => {
          this.imgPath = "data:image/png;base64," + res;
          this.submitLoading = false;
          this.QRVisible = true;
        });
      }
    },
    handleClick () {
      if (this.activeName == 1) {
        this.importVisible = true
      } else if (this.activeName == 2) {
        this.noticeDialogVisible = true;

      }
    },
    listMatching (name, idName, id, otherName) {
      this[name].forEach(item => {
        if (item.id == id) {
          this[idName] = otherName ? item[otherName] : item.autoInt;
          console.log(this[idName]);
          return
        }
      })

    },
    getBomUserList () {
      let sendData = {
        companyId: JSON.parse(window.localStorage.getItem('CompanyDetail')).id
      }
      console.log(sendData);

      this.$api.user.BomUserList(sendData).then((res) => {
        if (res.error === false) {
          this.AllData = res.data
          this.total = res.data.length
          this.getNewData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetImport () {
      this.$refs.upload.clearFiles();
    },
    PositionList () {
      this.listMatching('companyList', 'factAutoInt', this.topForm.customerId);
      this.listMatching('companyList', 'customerName', this.topForm.customerId, 'customerName');
      this.positionList = [];
      if (this.topForm.customerId) {
        let sendData = {
          customerId: this.topForm.customerId,
        };
        this.$api.posts.PositionAllList(sendData).then((res) => {
          if (res.error === false) {
            this.positionList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    //获取企业列表
    getCompanyList () {
      let sendData = {
        loading: false,
      };
      this.$api.customer.getAllCustomerList(sendData).then((res) => {

        if (res.error === false) {
          this.companyList = res.data;
          this.tableConfig[0].list = res.data;
        }
      });
    },
    // 打开并生成二维码
    openDialog () {

      this.QRVisible = true;
      this.$nextTick(() => {
        this.qrcode();
      });
    },
    introduce (value) {
      console.log(value);

      value.forEach((element) => {
        let obj = {};
        obj.userId = element.userId;
        obj.cname = element.cname;
        obj.identityCard = element.identityCard;
        obj.tel = element.tel;
        obj.defaultBankName = element.defaultBankName;
        obj.defaultBankNo = element.defaultBankNo;
        obj.emergencyContact = element.emergencyContact;
        obj.emergencyContactTel = element.emergencyContactTel;
        obj.sex = element.sex;
        obj.autoIntId = element.autoIntId;
        this.systemData.push(obj);
      });
      this.SalarySheetAdd('topForm', 'syste')

    },
    //返回
    goBack () {
      this.$router.go(-1);
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        if (v.userId) {
          return v.userId;
        } else {
          return v.flag;
        }
      });
      console.log(this.Ids);
    },

    uploadServe () {
      this.$refs.upload.submit();

    },
    // 上传文件的方法
    uploadfile (fileObj) {
      console.log(5555);

      this.submitLoading = true;
      this.readerXlsx(fileObj.file).then(res => {
        this.$set(this.topForm, 'userList', res)
        this.submitLoading = true;
        this.importVisible = false;
        this.activeName = '0';
        this.SalarySheetAdd('topForm', 'excel')
      })
    },
    readerXlsx (fileObj) {
      return new Promise((resolve, reject) => {
        const file = fileObj;
        const reader = new FileReader();
        // 处理文件内容
        reader.readAsArrayBuffer(file);
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = xlsx.read(data, { type: 'array' });

          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
          let array = []
          // 提取文件内容
          let headers = jsonData[0];
          this.total = jsonData.slice(1).length
          jsonData.slice(1).forEach(row => {
            const rowData = row.reduce((accumulator, item, index) => {
              let column = headers[index]
              let name = ''
              switch (column) {
                case '姓名(必填)':
                  name = 'cname';
                  break;
                case '性别':
                  name = 'sex';
                  break;
                case '手机号码':
                  name = 'tel';
                  break;
                case '紧急联系人':
                  name = 'emergencyContact';
                  break;
                case '紧急联系人电话':
                  name = 'emergencyContactTel';

                  break;
                case '身份证号码(必填)':
                  name = 'identityCard';

                  break;
                case '银行卡号':
                  name = 'defaultBankNo';

                  break;
                case '银行名称':
                  name = 'defaultBankName';

                  break;
                default:
                  break;
              }
              accumulator[name] = item;
              return accumulator
            }, {})
            array.push(rowData)
          })
          resolve(array)

        };
      })

    },
    SalarySheetAdd (formName, type) {
      if (type == 'only') {
        this.$refs[formName].validate((valid) => {

          if (!valid) return;
          let { cname, identityCard, tel } = this.topForm
          this.topForm.userList = [{ cname: cname, identityCard: identityCard, tel: tel }]
          this.topForm.customerName = this.customerName
          this.topForm.positionName = this.positionName
          this.$api.user.BomAdd(this.topForm).then((res) => {
            if (res.error === false) {
              this.$message.success('保存成功');
              delete this.topForm.cname
              delete this.topForm.identityCard
              delete this.topForm.tel

              this.getBomUserList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
      }
      else if (type == 'excel') {
        this.topForm.customerName = this.customerName
        this.topForm.positionName = this.positionName
        this.$api.user.BomAdd(this.topForm).then((res) => {
          if (res.error === false) {
            this.$message.success('保存成功');
            this.getBomUserList();
            // this.arrayList = []

          } else {
            this.$message.error(res.msg);
            // this.arrayList = []

          }

        });

      } else {
        this.topForm.userList = this.systemData;
        this.topForm.customerName = this.customerName
        this.topForm.positionName = this.positionName
        this.$api.user.BomAdd(this.topForm).then((res) => {
          if (res.error === false) {
            this.$message.success('保存成功');
            this.getBomUserList();
          } else {
            this.$message.error(res.msg);
          }

        });
        this.systemData = []

      }
    },
    getNewData () {
      const start = (this.$refs.pagination.currentPage - 1) * this.$refs.pagination.pageSize
      const end = start + this.$refs.pagination.pageSize
      setTimeout(() => {
        this.tableData = this.AllData.slice(start, end)

      }, 10)
    },
    onSubmit () {

      this.SalarySheetAdd('topForm', 'only');

    },
  },
};
</script>
<style lang="less" >
.quick {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
  .inputDeep {
    .el-input__inner {
      border: 1px solid red !important; //边框颜色
    }
  }
}
</style>
<style scoped lang="less">
.topForm {
  display: flex;
  flex-direction: column;
  // align-items: center;
  margin-top: 30px;
}
.gzt_title {
  text-align: center;
  // font-size: 22px;
}
.gzt_foundationBtn {
}
.gzt_functionBtn {
  text-align: center;
  margin-top: 20px;
}
.file,
.table {
  width: 100%;
  .title {
    display: flex;
    align-items: center;
    .num {
      // color: rgb(26, 210, 103);
      font-size: 22px;
      margin-right: 15px;
    }
  }

  .upload-demo {
    width: 100%;
    padding: 10px 70px;
    .el-upload-dragger {
      width: 100% !important;
    }
  }
  .result {
    padding: 10px 70px;
  }
}
</style>

